import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import PropTypes from 'prop-types';
import ModifyStrategyChip from './ModifyStrategyChip';

const AddStrategyButtonPicker = (props) => {
  const { resource } = props; // TODO: Should come from page content resource
  return pickFunction(resource, {
    [fr.relationships.item.name]: () => {
      return (
        <ModifyStrategyChip {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return (
        <ModifyStrategyChip {...props} disabled />
      );
    },
  });
};

AddStrategyButtonPicker.defaultProps = {
  className: '',
};

AddStrategyButtonPicker.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default AddStrategyButtonPicker;
